/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */

import React, {useEffect, useMemo, useState} from "react";
import sass from "./index.module.sass";
import InputTemp from "components-new/InputTemp";
import {$api} from "libs/axios";
import {initialIL, initialLocation} from "pages/StepPages/StepTwoDotTwo/modelTable";
import {Button} from "components/shared";
import {BUTTON_COLORS, BUTTON_VARIANTS} from "components/shared/Button/Button";
import {IOrganization} from "pages/StepPages/StepTwoDotTwo";
import {snackWrapper} from "helpers";

interface IHeader {
  id: number;
  name: string;
  key: keyof Omit<IOrganization, "name">;
}

interface ITab extends Omit<IHeader, "key"> {
}

interface ICreateTable {
  table: IHeader | null;
  tab: ITab | null;
  row: any | null;
  entryType: { [key: string]: any } | null;
}

// interface IOptions {
// 	id: number;
// 	address: string;
// }

const tables: IHeader[] = [
  {
    id: 1,
    name: "Расположение",
    key: "location",
  },
  {
    id: 2,
    name: "Перечень основных технических средств",
    key: "TTH",
  },
  {
    id: 3,
    name: "Операционные системы",
    key: "Soft",
  },
  {
    id: 4,
    name: "Программное обеспечение по введению данных",
    key: "IL",
  },
  {
    id: 5,
    name: "Перечень средств защиты информации",
    key: "MS",
  },
];

export const endPoints = {
  location: "/object/$id/location",
  TTH: "/object/$id/mean",
  Soft: "/object/$id/os",
  IL: "/object/$id/software",
  MS: "/object/$id/tool",
};

/**
 * Функция строит путь для обновления объекта, из ключа и идентификатора, который вставляется через регулярку
 * @param key - ключ внутренней таблицы, нужен для выбора поля с эндпоинтом
 * @param id - ID объекта который нужно обновить
 */
function createEndpoint(key: keyof typeof endPoints, id: number) {
  return endPoints[key].replace("$id", `${id}`);
}

/**
 * Константы для создания разделов
 */
// export const entryTypeMS = [
// 	{ id: 0, name: "Средства антивирусной защиты" },
// 	{ id: 1, name: "Средства защиты от несанкционированного доступа" },
// 	{ id: 2, name: "Средства контроля целостности ПО" },
// 	{ id: 3, name: "Средства защиты виртуализации" },
// 	{ id: 4, name: "Средства управления информационными потоками и защиты периметра ИС" },
// 	{ id: 5, name: "Средства обнаружения вторжений" },
// 	{ id: 6, name: "Средства обеспечения контроля защищенности информации" },
// 	{ id: 7, name: "Средства мониторинга результатов регистрации событий безопасности и реагирование на них" },
// 	{ id: 8, name: "Средства криптографической защиты информации для защиты каналов связи" },
// ];

export const entryTypeTTH = [
  {id: 0, name: "Виртуальные машины в ЦОД сегмент DMZ"},
  {id: 1, name: "Средства антивирусной защиты"},
];

interface ICreateRow {
  add: (key: keyof IOrganization, _: any) => void;
  meansOptions: { id: number; name: string }[];
  informOptions: { id: number; name: string }[];
  close: () => void;
  id: number;
}

const CreateRow: React.FC<ICreateRow> = ({add, close, id, meansOptions}) => {
  const [createRow, setCreateRow] = useState<ICreateTable>({
    tab: null,
    table: null,
    row: null,
    entryType: null,
  });

  // const [loadAddress, setLoadAddress] = useState(false);

  const [search, setSearch] = useState("");

  // const [address, setAddress] = useState<IOptions[]>([]);

  const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCreateRow((prevState) => {
      const newState = {...prevState};
      if (Array.isArray(prevState.row)) {
        newState.row = [...prevState.row].map((_) => (_.key === e.target.name ? {..._, value: e.target.value} : _));
      } else {
        newState.row = {...prevState.row, [e.target.name]: e.target.value};
      }
      return newState;
    });
  };

  // function requestAddress(search: string) {
  // 	$api.get(``).then((r) => {
  // 		setAddress(r.data);
  // 		setLoadAddress(false);
  // 	});
  // }

  const [influenceObjects, setInfluenceObjects] = useState<any[]>([]);
  const [selectedInfluence, setSelectedInfluence] = useState<{ id: number; name: string } | null>(null);
  useEffect(() => {
    $api.get(`/directory/dropdown/object/additional/influences`).then((r) => {
      setInfluenceObjects(r.data.map((item: string, i: number) => ({id: i + 1, name: item})));
    });
  }, []);

  const initial = (table:typeof createRow.table) => {
    if (table) {
      switch (table.key) {
        case "TTH":
          return initialIL;
        case "MS":
          return initialIL;
        case "location":
          let temp: any = {};
          initialLocation.forEach((_) => {
            temp[_.key] = _.value;
          });
          return temp;
        case "Soft":
          return initialIL;
        case "IL":
          return initialIL;
      }
    }
    return null;
  };

  // const dependencies = useMemo(() => {
  // 	if (createRow.table) {
  // 		switch (createRow.table.key) {
  // 			case "TTH":
  // 				return createRow.row && createRow.row.every((_: any) => _.value) && !!selectedInfluence?.name;
  // 			case "MS":
  // 				return createRow.row && createRow.row.every((_: any) => _.value) && !!selectedInfluence?.name;
  // 			case "location":
  // 				return !!createRow.row?.name && !!createRow.row?.address;
  // 			case "IL":
  // 				return createRow.row && createRow.row.every((_: any) => _.value);
  // 		}
  // 	}
  // 	return false;
  // }, [createRow, selectedInfluence]);
  // useEffect(() => {
    // if (initial) {
    //   console.log(initial)
    //   setCreateRow((prevState) => ({...prevState, row: initial(createRow.table)}));
    // }
  // }, []);

  // const debounce = useDebounce(search || "", 300);

  // useEffect(() => {
  // 	setLoadAddress(true);
  // 	// requestAddress(debounce as string);
  // }, [debounce]);

  const disabled = useMemo(() => {
    if (createRow.row && createRow.row.length) {
      let rest: { [key: string]: any } = {};
      if (createRow.table && (createRow.table.key === "TTH" || createRow.table.key === "MS")) {
        const requiredFields = createRow.row.filter((_: { [key: string]: any }) => _?.required);
        requiredFields.forEach((_: any) => (rest[_.key] = _.value));
        return !requiredFields.every((_: { [key: string]: any }) => _.value) || !selectedInfluence?.id;
      }
    }
    return false;
  }, [createRow.row, createRow.table, selectedInfluence]);

  function saveRow() {
    let uploadDate: any;
    let rest: any = {};
    switch (createRow.table?.key) {
      case "TTH":
        createRow.row.forEach((_: any) => (rest[_.key] = _.value));
        uploadDate = {...rest, segment: createRow.entryType?.name, objectInfluence: selectedInfluence?.name || ""};
        break;
      case "MS":
        createRow.row.forEach((_: any) => (rest[_.key] = _.value));
        uploadDate = {...rest,
          objectInfluence: selectedInfluence?.name || "",
        };

        // uploadDate = {
        //   ...rest,
        //   segment: createRow.entryType?.name,
        //   quantity: +rest.quantity,
        //   unitWeight: +rest.unitWeight,
        //   objectInfluence: selectedInfluence?.name || "",
        // };
        break;
      case "location":
        uploadDate = {address: createRow.row?.address.id, name: createRow.row?.name};
        break;
      case "IL":
        createRow.row.forEach((_: any) => (rest[_.key] = _.value));
        uploadDate = {...rest,
          objectInfluence: selectedInfluence?.name || "",
        };
        break;
      case "Soft":
        createRow.row.forEach((_: any) => (rest[_.key] = _.value));
        uploadDate = {...rest,
          objectInfluence: selectedInfluence?.name || "",
        };
        break;
    }
    if (createRow.table && createRow.table.key) {
      const endpoint = createEndpoint(createRow.table.key, id);
      console.log(uploadDate)
      $api.post(endpoint, {...uploadDate}).then((r) => {
        add(createRow.table!.key, r.data);
        snackWrapper("success", "Успешно сохранено");
        close();
      });
    }
  }

  console.log(meansOptions)
  return (
    <div className={sass.wrapper}>
      <InputTemp
        label={"Выберите таблицу"}
        onSelect={(obj) => {
          setCreateRow({
            table: obj,
            row: initial(obj),
            tab: null,
            entryType: obj.key === "TTH" ? {} : null,
          });
        }}
        readOnly={true}
        placeholder={"Не выбрано"}
        name={"table"}
        value={createRow.table?.name || ""}
        type={"select"}
        options={tables}
        currentValue={createRow.table || undefined}
        field={"name"}
      />
      {createRow.table && createRow.row && createRow.table.key === "location" ? (
        <>
          <InputTemp
            label={"Наименование сегмента"}
            name={"name"}
            value={createRow.row!.name || ""}
            field={"name"}
            isCreated
            remote={{
              link: "/directory/dropdown/segment/names",
              initialParams: {page: 1, num: 20},
              isStringList: true,
            }}
            onSelect={(e) => {
              const event = {
                target: {
                  name: "name",
                  value: e.name,
                },
              };
              changeField(event as any);
            }}
            onChange={(e) => {
              changeField(e);
            }}
          />
          <InputTemp
            label={"Адрес размещения объекта"}
            name={"address"}
            remote={{
              link: "/directory/construction-objects/search",
              initialParams: {query: ""},
            }}
            value={search || ""}
            onSelect={(e) => {
              setSearch(e.address);
              setCreateRow((prevState) => {
                const newState = {...prevState};
                if (prevState.row) {
                  newState.row = {...prevState.row, address: e};
                } else {
                  (newState.row as any) = {
                    address: e,
                  };
                }
                return newState;
              });
            }}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            currentValue={createRow.row.address}
            field={"address"}
          />
        </>
      ) : createRow.table?.key === "TTH" ? (
        <>
          <InputTemp
            label={"Раздел таблицы"}
            name={"entryType"}
            value={createRow?.entryType?.name || ""}
            placeholder={"Не выбрано"}
            readOnly={true}
            onSelect={(obj) => {
              setCreateRow((prevState) => ({...prevState, entryType: obj}));
            }}
            emptySearch
            options={meansOptions || entryTypeTTH}
            currentValue={createRow.entryType || undefined}
            field={"name"}
            type={"select"}
          />
          {createRow.entryType?.id >= -1 && createRow.row&& Array.isArray(createRow.row) && (
            <>
              {createRow.row.map((_: any, index: number) => (
                <InputTemp
                  key={index}
                  required={_.required}
                  label={_.td}
                  name={_.key}
                  value={_.value}
                  onChange={(e) => {
                    changeField(e);
                  }}
                  type={"input"}
                />
              ))}
              <InputTemp
                required={true}
                label={"Объект воздействия"}
                onSelect={(selected) => setSelectedInfluence(selected)}
                readOnly={true}
                placeholder={"Не выбрано"}
                // name={"table"}
                value={selectedInfluence?.name || ""}
                type={"select"}
                options={influenceObjects}
                currentValue={selectedInfluence || undefined}
                field={"name"}
              />
            </>
          )}
        </>
      ) : createRow.table?.key && createRow.row && Array.isArray(createRow.row) && (
        <>
          {createRow.row.map((_: any, index: number) => (
            <InputTemp
              key={index}
              label={_.td}
              name={_.key}
              value={_.value}
              onChange={(e) => {
                changeField(e);
              }}
              type={"input"}
            />
          ))}
        <InputTemp
          required={true}
          label={"Объект воздействия"}
          onSelect={(selected) => setSelectedInfluence(selected)}
          readOnly={true}
          placeholder={"Не выбрано"}
          // name={"table"}
          value={selectedInfluence?.name || ""}
          type={"select"}
          options={influenceObjects}
          currentValue={selectedInfluence || undefined}
          field={"name"}
        />
        </>
      )
        // : (
        // (createRow.table?.key === "MS" ) && Array.isArray(createRow.row) && createRow.entryType?.id >= -1 &&
        // // createRow.entryType &&
        // (
        //   <>
        //     {/*<InputTemp*/}
        //     {/*	label={"Раздел таблицы"}*/}
        //     {/*	name={"entryType"}*/}
        //     {/*	value={createRow?.entryType?.name || ""}*/}
        //     {/*	placeholder={"Не выбрано"}*/}
        //     {/*	readOnly={true}*/}
        //     {/*	onSelect={(obj) => {*/}
        //     {/*		setCreateRow((prevState) => ({ ...prevState, entryType: obj }));*/}
        //     {/*	}}*/}
        //     {/*	options={informOptions}*/}
        //     {/*	currentValue={createRow.entryType || undefined}*/}
        //     {/*	field={"name"}*/}
        //     {/*	type={"select"}*/}
        //     {/*/>*/}
        //     {/*{createRow.entryType?.id >= 0 && createRow.row && (*/}
        //     {/*	<>*/}
        //     {createRow.row?.map((_: any, index: number) => {
        //       if (_.key === "quantity" || _.key === "unitWeight") {
        //         return (
        //           <InputTemp
        //             key={index}
        //             label={_.td}
        //             required={_.required}
        //             name={_.key}
        //             value={_.value}
        //             onKeyDown={(e) => {
        //               if (
        //                 (e.key === "." || e.key === ",") &&
        //                 (e.currentTarget.value.indexOf(".") !== -1 || e.currentTarget.value.indexOf(",") !== -1)
        //               ) {
        //                 e.preventDefault();
        //               }
        //             }}
        //             onChange={(evt) => {
        //               let value;
        //               value = evt.target.value.replace(/[^0-9.,]/g, "").replace(/,/g, ".");
        //               if (/^\./.test(value)) {
        //                 value = 0 + value;
        //               }
        //               evt.target.value = value;
        //               changeField(evt);
        //             }}
        //             type={"input"}
        //           />
        //         );
        //       }
        //       return (
        //         <InputTemp
        //           key={index}
        //           label={_.td}
        //           required={_.required}
        //           name={_.key}
        //           value={_.value}
        //           onChange={(e) => {
        //             changeField(e);
        //           }}
        //           type={"input"}
        //         />
        //       );
        //     })}
        //     <InputTemp
        //       required={true}
        //       label={"Объект воздействия"}
        //       onSelect={(selected) => setSelectedInfluence(selected)}
        //       readOnly={true}
        //       placeholder={"Не выбрано"}
        //       // name={"table"}
        //       value={selectedInfluence?.name || ""}
        //       type={"select"}
        //       options={influenceObjects}
        //       currentValue={selectedInfluence || undefined}
        //       field={"name"}
        //     />
        //     {/*</>*/}
        //     {/*)}*/}
        //   </>
        // )
      // )
      }
      <div className={sass.btn}>
        <Button variant={BUTTON_VARIANTS.OUTLINED} onClick={close} full={true}>
          Отменить
        </Button>
        <Button disabled={disabled} color={BUTTON_COLORS.PRIMARY} onClick={saveRow} full={true}>
          Сохранить
        </Button>
      </div>
    </div>
  );
};
export default CreateRow;
